import { DataEntry, MetadataCard } from '@common/components/MetadataCard';
import { useSelectedCollection } from '@features/Collection/hooks';
import { CollectionTechnicalDetails } from '@features/Collection/types';
import { useTranslation } from 'react-i18next';

export const TechnicalDetailsSection = () => {
    const { t } = useTranslation('collectionDetails');
    const {
        selectedCollection: { technicalDetails },
        isLoading,
    } = useSelectedCollection();

    // if (!technicalDetails || isEmpty(technicalDetails)) return null;

    const displayOrder: (keyof CollectionTechnicalDetails)[] = [
        'volume',
        'assetCount',
        'deliverables',
        'stl',
        'audioLanguages',
        'resolutions',
        'colorSpaces',
        'aspectRatios',
    ] as const;

    const translatedMetadataObject = displayOrder.reduce((acc, key) => {
        const rawValue = technicalDetails?.[key];
        const value = Array.isArray(rawValue) ? rawValue.join(', ') : rawValue;
        acc.push({ label: t(`technicalDetails.${key}`), value });
        return acc;
    }, [] as DataEntry[]);

    return (
        <MetadataCard
            data-radius={'0'}
            title={t('technicalInformation')}
            data={translatedMetadataObject}
            columns={2}
            rows={3}
            isLoading={isLoading}
        />
    );
};
